import React from "react";
import Icon from "@mdi/react";

export const MiIcon = ({ path, size, color, ...rest }) => {
  return <Icon path={path} size={size || 1} color={color} {...rest} />;
};
